<template>
    <van-popup v-model:show="show" position="right" :style="{
        minWidth: '100%',
        minHeight: '100%',
        color: '#fff',
        overflow: 'hidden',
    }">
        <div class="popupContainer">
            <CustomHeader :text="$t('common.history')" @closePopup="close" bgColor="#024a49" />
            <div class="historyContainer">
                <NoData v-if="historyList?.length <= 0" />
                <div class="cardcontainer" v-for="(item, index) in historyList" :key="index">
                    <van-row>
                        <van-col span="6" class="dayColumn">
                            <div class="dayImage2">
                                <img src="@/assets/themeFour/CalenderGreen.png" alt="">
                                <div class="dateText" style="font-size: 12px;">{{ item?.rewardDate?.split(' ')[0] }}
                                </div>
                            </div>
                        </van-col>
                        <van-col span="12" class="topRow" style="margin: 10px 0;">
                            <div class="dayTitle" style="font-size: 12px;">{{ $t('activity.claimAmount') }} : <span
                                    style="padding-left: 10px;"> {{ formatCurrency(item?.coin) }}</span></div>
                        </van-col>
                        <van-col span="6" class="dayColumn">
                            <span class="right-texts">
                                <p v-if="item?.status == 0" style="color: #0484ff;">{{
                                    $t('activityStatus.pending') }}</p>
                                <p v-else-if="item?.status == 1" style="color: #36d836;">{{
                                    $t('activityStatus.completed')
                                }}</p>
                                <p v-else-if="item?.status == 2" style="color: #ff0000;">{{
                                    $t('activityStatus.noRewards')
                                }}</p>
                                <p v-else-if="item?.status == 3" style="color: #ff0000;">{{ $t('activity.overdue')
                                }}</p>
                            </span>
                        </van-col>
                    </van-row>
                </div>

                <van-row v-if="total > pageNum * pageSize">
                    <van-col span="24" class="arrowDown"> <img src="@/assets/home/game_arrow_white.png" alt=""
                            @click="getNextPageRewardData"></van-col>
                </van-row>
                <div v-if="historyList?.length != 0 && total < pageNum * pageSize" class="no_more">{{
                    $t('message.noMore') }}</div>

            </div>
        </div>

    </van-popup>
    <LoadingScreen ref="loadingRef" />
    <StatusPopup ref="statusRef" :is-show-success="isSuccess" :content="toastContent" />
</template>

<script setup lang="ts">
import { ref, PropType, computed } from 'vue'
import StatusPopup from '@/components/common/statusPopup.vue'
import LoadingScreen from '@/components/common/loadingScreen.vue'
import { useI18n } from 'vue-i18n';
import { checkinRewardsHistory } from '@/api/activity';
import { formatCurrency } from '@/utils/commonFunction';
import NoData from '../../components/common/noData.vue';
import CustomHeader from '../../components/common/customHeader.vue';
const PAGE_SIZE = 20
const props = defineProps({
    list: {
        type: Array as PropType<(any)[]>,
        default: () => []
    },
    showIcon: {
        type: Boolean
    },
    title: String,
    isUseFirstRecharge: {
        type: Boolean,
        default: () => false
    }
})
const { t } = useI18n();
const show = ref(false)
const isSuccess = ref(false)
const statusRef = ref()
const toastContent = ref('')
const historyList = ref<any[]>([])
const loadingRef = ref()
const pageSize = ref(PAGE_SIZE)
const pageNum = ref(1)
const total = ref(0)
const open = () => {
    show.value = true
    getHistory()
}

const close = () => {
    show.value = false
    historyList.value = []
    total.value = 0
    pageNum.value = 1
}
const getHistory = () => {
    checkinRewardsHistory().then(res => {
        loadingRef.value.close()
        total.value = res.data.total
        historyList.value = [...historyList.value, ...res.data.rows]
    }).catch(err => {
        loadingRef.value.close()
        showError(err);
    })
}
const showError = (message: string) => {
    toastContent.value = message;
    isSuccess.value = false;
    statusRef.value.open()
}
const getNextPageRewardData = () => {
    if (total.value > pageSize.value) {
        loadingRef.value.open()
        getHistory()
        pageSize.value = pageSize.value + 10
    }
}
defineExpose({
    open,
    close
})
</script>
<style scoped>
.popupContainer {
    background: #003534;
    width: 100%;
    height: 100vh;
    overflow: hidden;
}

.historyContainer {
    padding: 60px 15px;
    height: calc(100vh - 50px);
    overflow-y: auto;
    box-sizing: border-box;
    scrollbar-width: none;
    -ms-overflow-style: none;
}

.historyContainer::-webkit-scrollbar {
    display: none;
}

.cardcontainer {
    background: #002121;
    /* box-shadow: 0px 2px 4px 0px #622a7b; */
    border-radius: 10px;
    padding: 10px 5px;
    color: #fff;
    font-size: 12px;
    margin: 10px 0 0;
}

.dayColumn {
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    align-items: center;
}

.right-texts {
    margin: 0;
}

.right-texts p {
    text-align: center;
    display: flex;
}

.dayImage2 img {
    width: 75px;
    height: 50px;
    position: relative;
}

.dayImage2 {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
}

.topRow {
    display: flex;
    text-align: center;
    align-items: center;
    justify-content: center;
    flex-direction: column;
}

.dayTitle {
    font-weight: bold;
    color: #fff;
}

.dateText {
    position: absolute;
    top: 50%;
    padding: 5px 0;
    font-size: 6px;
    color: #000;
    font-weight: 600;
}

.arrowDown {
    display: flex;
    justify-content: center;

}

.arrowDown img {
    width: 25px;
    transform: rotate(-90deg);
    padding: 10px;
}

.no_more {
    color: rgba(255, 255, 255, 0.25);;
    display: flex;
    justify-content: center;
    padding: 10px;
    font-size: 14px;
    font-weight: 400
}
</style>